export default __webpack_public_path__ + "static/media/ss-pika.1cb15df5.eot";